export default __webpack_public_path__ + "static/favicon-db3935ee952106087530840ea8c61254.ico";